/**
 * fieldTypes.js — the form-field registry for Event Pre-Orders.
 *
 * This is the single source of truth that both the admin builder (FieldEditor)
 * and the public renderer (FieldRenderer) read from. The event's form is stored
 * as JSON (an array of field objects), so adding a brand-new field type is a
 * one-line change here — no builder/renderer code changes required.
 *
 *   hasOptions  → field carries an `options: []` array (dropdown / choices)
 *   input       → false for presentational blocks (headings) that collect no value
 */

export const FIELD_TYPES = [
  { type: 'heading',       label: 'Section Heading', icon: '📌', hasOptions: false, input: false },
  { type: 'short_text',    label: 'Short Text',      icon: '✏️', hasOptions: false, input: true  },
  { type: 'long_text',     label: 'Paragraph',       icon: '📝', hasOptions: false, input: true  },
  { type: 'number',        label: 'Number',          icon: '🔢', hasOptions: false, input: true  },
  { type: 'dropdown',      label: 'Dropdown',        icon: '🔽', hasOptions: true,  input: true  },
  { type: 'single_choice', label: 'Single Choice',   icon: '⚪', hasOptions: true,  input: true  },
  { type: 'multi_choice',  label: 'Checkboxes',      icon: '☑️', hasOptions: true,  input: true  },
  { type: 'date',          label: 'Date',            icon: '📅', hasOptions: false, input: true  },
  { type: 'time',          label: 'Time',            icon: '⏰', hasOptions: false, input: true  },
  { type: 'email',         label: 'Email',           icon: '📧', hasOptions: false, input: true  },
  { type: 'phone',         label: 'Phone',           icon: '📞', hasOptions: false, input: true  },
];

export const FIELD_TYPE_MAP = Object.fromEntries(FIELD_TYPES.map((f) => [f.type, f]));

/** Does this field type carry a list of options (dropdown / radio / checkboxes)? */
export function fieldHasOptions(type) {
  return !!FIELD_TYPE_MAP[type]?.hasOptions;
}

/** Presentational blocks (headings) return false — they collect no answer. */
export function fieldIsInput(type) {
  return FIELD_TYPE_MAP[type]?.input !== false;
}

/** Multi-select fields hold an array value; everything else holds a scalar. */
export function fieldIsMulti(type) {
  return type === 'multi_choice';
}
